import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import ModalMixin from '@/mixins/modal-mixin';
import ExamModalNew from '@/Pages/People/Customer/ExamModalNew.vue';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapActions, mapGetters, mapState } from 'vuex';
let PendingExamsBarComponent = class PendingExamsBarComponent extends Mixins(ModalMixin) {
    fetchExams;
    fetchCustomers;
    findExamsFromStore;
    getCustomersFromStore;
    user;
    areCustomersLoading;
    areExamsLoading;
    get isDataReady() {
        return !this.areCustomersLoading && !this.areExamsLoading;
    }
    get fetchParams() {
        return {
            query: {
                reviewed: false,
                userId: this.user._id,
            }
        };
    }
    get exams() {
        return this.findExamsFromStore(this.fetchParams).data;
    }
    get hasPendingExams() {
        return this.exams.length > 0;
    }
    get pendingExamsCustomersIds() {
        return this.exams.map((exam) => exam.customerId);
    }
    get pendingExamsWithCustomers() {
        return this.exams.filter((value, index, self) => self.findIndex((exam) => (exam.customerId === value.customerId)) === index).map(exam => ({
            ...exam,
            customer: this.getCustomersFromStore(exam.customerId),
        }));
    }
    onIdsChanged(pendingExamsCustomersIds) {
        this.fetchCustomers({
            query: {
                _id: {
                    $in: pendingExamsCustomersIds
                }
            }
        });
    }
    openNewExamsForCustomer(customer) {
        const { Treatment } = this.$FeathersVuex;
        new Treatment({
            _id: 'temp',
            data: {
                resultExams: this.exams.filter(exam => exam.customerId === customer._id),
                kid: this.$moment().diff(this.$moment(customer.birth_date), 'year') < 18,
            }
        });
        this.openModal({
            id: 'examModalNewOnTopBar'
        });
    }
    mounted() {
        this.fetchExams(this.fetchParams);
    }
};
__decorate([
    Watch('pendingExamsCustomersIds')
], PendingExamsBarComponent.prototype, "onIdsChanged", null);
PendingExamsBarComponent = __decorate([
    Component({
        name: 'pending-exams-bar',
        components: {
            Avatar,
            ExamModalNew,
        },
        computed: {
            ...mapGetters('exam', { findExamsFromStore: 'find' }),
            ...mapGetters('customers', { getCustomersFromStore: 'get' }),
            ...mapState('auth', ['user']),
            ...mapState('customers', { areCustomersLoading: 'isFindPending' }),
            ...mapState('exam', { areExamsLoading: 'isFindPending' }),
        },
        methods: {
            ...mapActions('exam', { fetchExams: 'find' }),
            ...mapActions('customers', { fetchCustomers: 'find' }),
        },
    })
], PendingExamsBarComponent);
export default PendingExamsBarComponent;
